import styled, { css } from 'styled-components'
import { Form } from 'semantic-ui-react'

import Icon from '../Icon'

export const StyledSelect = styled(Form.Select)`
  ${({ disabled }) => css`
    .selection > div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      min-height: 15px;
    }

    ${disabled &&
    css`
      i.icon.clear,
      i.icon.delete {
        display: none !important;
      }
    `}
  `}
`

export const AngleDownIcon = styled(Icon).attrs({
  button: true,
  name: 'icon-angle-down',
})`
  &&& {
    font-size: 20px !important;
    position: absolute;
    right: 2px;
    top: 7px;
  }
`
